import React from 'react';

const BtnBack = (props) => {
  return <button id='btnBack' className='btn-back' onClick={props.onclick}></button>;
};

export default BtnBack;
